import DOMPurify from 'dompurify';
import parseHTML from 'html-react-parser';
import linkifyHtml from 'linkify-html';
import {ReactNode} from 'react';

/**
 * Parses a string to contain HTML escape characters.
 *
 * @param {string} unsafe - The string to add escape chars to.
 */
export function escapeHtml(unsafe: string): string {
  return unsafe
    ?.replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/**
 * Sanitizes a string by escaping HTML chars and returns a newly parsed element.
 * Relevant to protect against cross-site scripting.
 *
 * @param {string} inputString - The string to sanitize.
 * @param {boolean} parse - Whether to parse the sanitized output as HTML nodes
 */
export function sanitizeString(inputString: string, parse: boolean = true): ReactNode {
  let outputString = DOMPurify.sanitize(inputString);
  outputString = linkifyHtml(outputString).replace(/href/g, "target='_blank' href");
  return parse ? parseHTML(outputString) : outputString;
}
